import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, ArrowRight } from "lucide-react";
import Layout from "../components/Layout";
import { useAuth } from "../context/AuthContext";
import { TIER_NAME, nextTier, TIER_LABEL } from "../lib/tiers";
import api from "../lib/api";

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const nt = nextTier(user.tier);

  useEffect(() => {
    // Members can't hit admin orders; show their membership orders from purchase history via a light call.
    api.get("/consultations").catch(() => {});
  }, []);

  return (
    <Layout>
      <div className="section-pad max-w-3xl mx-auto">
        <h1 className="font-display text-4xl font-semibold text-brand-ink">Account & Billing</h1>

        <div className="card-surface p-6 mt-6">
          <h3 className="font-semibold text-brand-ink">Profile</h3>
          <dl className="mt-3 space-y-2 text-sm">
            <div className="flex justify-between"><dt className="text-brand-muted">Name</dt><dd className="text-brand-ink" data-testid="account-name">{user.name}</dd></div>
            <div className="flex justify-between"><dt className="text-brand-muted">Email</dt><dd className="text-brand-ink" data-testid="account-email">{user.email}</dd></div>
            <div className="flex justify-between items-center"><dt className="text-brand-muted">Current Tier</dt>
              <dd><span className="pill text-white" style={{ background: user.tier === "diamond" ? "#4F8176" : user.tier === "gold" ? "#C59B27" : "#718078" }}><Award size={12} className="inline mr-1" />{TIER_NAME[user.tier]}</span></dd>
            </div>
          </dl>
        </div>

        {nt && (
          <div className="card-surface p-6 mt-5 flex items-center justify-between">
            <div>
              <h3 className="font-semibold text-brand-ink">Upgrade Available</h3>
              <p className="text-sm text-brand-muted mt-1">Unlock more with {TIER_NAME[nt]}.</p>
            </div>
            <Link to={`/packages?tier=${nt}&checkout=true`} className="btn-primary !py-2 text-sm" data-testid="account-upgrade">Upgrade to {TIER_LABEL[nt]} <ArrowRight size={16} /></Link>
          </div>
        )}

        <div className="card-surface p-6 mt-5">
          <h3 className="font-semibold text-brand-ink">Order History</h3>
          <p className="text-sm text-brand-muted mt-2">Your membership and shop orders will appear here. Receipts are emailed to {user.email}.</p>
        </div>
      </div>
    </Layout>
  );
}
